export const OFFER_STATUS_COLORS = {
  pending:
    "bg-[hsl(var(--ds-primary)/0.12)] text-[hsl(var(--ds-primary))] border border-[hsl(var(--ds-primary)/0.25)]",
  negotiating:
    "bg-[hsl(var(--ds-warning)/0.15)] text-[hsl(var(--ds-warning-fg))] border border-[hsl(var(--ds-warning)/0.35)]",
  accepted:
    "bg-[hsl(var(--ds-success)/0.12)] text-[hsl(var(--ds-success))] border border-[hsl(var(--ds-success)/0.25)]",
  declined:
    "bg-[hsl(var(--ds-danger)/0.12)] text-[hsl(var(--ds-danger))] border border-[hsl(var(--ds-danger)/0.25)]",
};

export const OFFER_ACTION_LABELS = {
  offer_issued: 'Offer issued',
  accepted: 'Candidate accepted',
  negotiate: 'Negotiation requested',
  declined: 'Offer declined',
  staff_reply: 'Employer reply',
  terms_accepted: 'Terms accepted',
  offer_revised: 'Offer revised'
};

export const ONBOARDING_DOCUMENT_TYPES = [
  { code: 'aadhar', label: 'Aadhar' },
  { code: 'pan', label: 'PAN' },
  { code: 'educational', label: 'Educational certificates' },
  { code: 'professional', label: 'Professional / experience' },
  { code: 'bank', label: 'Bank details / cancelled cheque' },
  { code: 'photo_id', label: 'Photo ID' },
  { code: 'address_proof', label: 'Address proof' },
  { code: 'appointment_letter', label: 'Signed appointment / offer letter' },
  { code: 'medical', label: 'Medical / fitness certificate' },
  { code: 'other', label: 'Other' }
];

export const PACKAGE_TYPES = [
  { value: 'annual', label: 'Per annum (CTC)' },
  { value: 'monthly', label: 'Per month' }
];

export const EMPLOYMENT_TYPES = [
  { value: 'full-time', label: 'Full-time' },
  { value: 'part-time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'intern', label: 'Internship' }
];

export const CURRENCIES = ['INR', 'USD', 'EUR', 'GBP'];

export function emptyOfferDetails(overrides = {}) {
  return {
    designation: '',
    department: '',
    package: '',
    packageType: 'annual',
    currency: 'INR',
    expectedJoiningDate: '',
    workLocation: '',
    employmentType: 'full-time',
    probationPeriod: '',
    benefits: '',
    additionalNotes: '',
    ...overrides
  };
}

export function offerDetailsValid(details) {
  return !!(details?.designation?.trim() && details?.package?.trim() && details?.expectedJoiningDate);
}
